import React from 'react';
import { FocusedCard, Spin } from '@brokerbay/design-components';

export interface LoadingViewProps {
  includeLayout?: boolean;
}

export const LoadingView = ({ includeLayout }: LoadingViewProps) => {
  if (includeLayout)
    return (
      <FocusedCard>
        <Spin size="large" center />
      </FocusedCard>
    );
  return <Spin size="large" center />;
};
